import MembersRouter from './Members.router';
export { default as membersRoutes } from './routes';

export default MembersRouter;
